import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
type FormLabelProps = Pick<React.LabelHTMLAttributes<HTMLLabelElement>, 'htmlFor' | 'className'> & {
  size?: NonNullable<VariantProps<typeof formLabelVariant>['size']>;
  weight?: NonNullable<VariantProps<typeof formLabelVariant>['weight']>;

  /** If `true` it appends a '*' to the label
   * @default false */
  required?: boolean;
} & ({
  /** @deprecated use the `children` prop instead. */
  label?: React.ReactNode;
} | {
  children?: React.ReactNode;
});
export const formLabelVariant = cva(['block select-none'], {
  variants: {
    color: {
      primary: 'text-primary',
      'blue-500': 'text-blue-500'
    },
    size: {
      sm: 'text-sm leading-5',
      md: 'text-md leading-6'
    },
    weight: {
      bold: 'font-bold',
      medium: 'font-medium',
      regular: ''
    }
  },
  defaultVariants: {
    color: 'primary',
    size: 'sm',
    weight: 'medium'
  }
});
export default function FormLabel(t0) {
  const $ = _c(18);
  let className;
  let htmlFor;
  let props;
  let size;
  let weight;
  if ($[0] !== t0) {
    ({
      htmlFor,
      className,
      size,
      weight,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = htmlFor;
    $[3] = props;
    $[4] = size;
    $[5] = weight;
  } else {
    className = $[1];
    htmlFor = $[2];
    props = $[3];
    size = $[4];
    weight = $[5];
  }
  const children = "children" in props ? props.children : "label" in props ? props.label : null;
  const t1 = htmlFor && "cursor-pointer";
  let t2;
  if ($[6] !== className || $[7] !== size || $[8] !== t1 || $[9] !== weight) {
    t2 = formLabelVariant({
      size,
      weight,
      className: [t1, className]
    });
    $[6] = className;
    $[7] = size;
    $[8] = t1;
    $[9] = weight;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== props) {
    t3 = children && (props.required === true ? <>{children}{" *"}</> : children);
    $[11] = children;
    $[12] = props;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== htmlFor || $[15] !== t2 || $[16] !== t3) {
    t4 = <label htmlFor={htmlFor} className={t2}>{t3}</label>;
    $[14] = htmlFor;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}